
import LampSlash from "../../../assets/outline/LampSlash.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function LampSlashIcon({ className, dataTestid = "LampSlashIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <LampSlash data-testid={dataTestid} className={classes} {...rest} />
  );
}
